// API Configuration
export const BACKEND_URL =
  import.meta.env.VITE_BACKEND_URL ||
  (import.meta.env.DEV ? "http://localhost:5000" : "");

export const API_ENDPOINTS = {
  CONTACT: `${BACKEND_URL}/api/contact`,
  HEALTH_CHECK: `${BACKEND_URL}/api/health_check`,
  CHECK_PRIVACY: `${BACKEND_URL}/api/check_privacy`,
};

export const COMPANY_EMAIL = "info@zeroharmai.com";

// Health check configuration
export const HEALTH_CHECK_CONFIG = {
  TIMEOUT: 10000, // 10 seconds timeout for cold start
  RETRY_INTERVAL: 2000, // Retry every 2 seconds
  MAX_RETRIES: 5, // Max 5 retries (10 seconds total)
};
